import {
  SET_COMPANY_NAME,
  SET_COMPANY_TOKEN,
  SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED,
  SET_COMPANY_IMAGE_PROTECTION_ENABLED,
  SET_COMPANY_IMAGE_PROTECTION_STYLE,
} from '../actions/action_company';
import {
  DEFAULT_OVERLAY_STYLE,
  isSupportedOverlayStyle,
} from '../components/v3/shared/protectedImage/overlayStyles';

const INITIAL_STATE = {
  name: '', // This is actually the CSS class name, kept for backward compatibility
  token: '', // This is the actual company identifier (auth_token value)
  nonUsInternationalizationEnabled: false,
  imageProtectionEnabled: false,
  imageProtectionStyle: DEFAULT_OVERLAY_STYLE,
};

export default function (state = INITIAL_STATE, action) {
  Object.freeze(state);

  switch (action.type) {
    case SET_COMPANY_NAME:
      // Sets the CSS class name (from data.css)
      return { ...state, name: action.payload };
    case SET_COMPANY_TOKEN:
      // Sets the company identifier (from data.token)
      return { ...state, token: action.payload };
    case SET_COMPANY_NON_US_INTERNATIONALIZATION_ENABLED:
      return { ...state, nonUsInternationalizationEnabled: action.payload };
    case SET_COMPANY_IMAGE_PROTECTION_ENABLED:
      return { ...state, imageProtectionEnabled: action.payload };
    case SET_COMPANY_IMAGE_PROTECTION_STYLE:
      // A stale bundle, or a company record predating the column, must still
      // render today's treatment rather than nothing.
      return {
        ...state,
        imageProtectionStyle: isSupportedOverlayStyle(action.payload)
          ? action.payload
          : DEFAULT_OVERLAY_STYLE,
      };
    default:
      return state;
  }
}
